import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../assets/Icon";

function TranscriptSection({ loginQuery }) {
  return (
    <div className="mt-10">
      <div className="flex gap-3 items-center font-semibold text-[1.275rem]">
        <div className="bg-[#206DC5] border inline-block p-3 rounded-xl">
          <Icon type="report-transcript-icon" width="18" height="19" />
        </div>
        <span>Transcription</span>
      </div>
      <div className="report-transcript-section flex flex-col lg:flex-row justify-between gap-3 items-start lg:items-center mt-[.35rem]">
        <div className="transcript-heading text-[#475467] font-medium text-[1.1rem] w-full lg:w-[60%] leading-6 px-1">
          Access the full transcription here to view it online or download a
          copy for later.
        </div>

        <Link to={`/transcript?q=${loginQuery}`} target="_blank">
          <button className="flex items-center justify-center gap-2 px-[.85rem] py-3 bg-[#206DC5] text-white font-semibold rounded-md">
            <Icon type="report-eye-icon" width="28" height="22" />{" "}
            <span className="text-[.95rem]">
              View Detailed Transcription Analysis
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
}

export default TranscriptSection;
